import menu from './menu';
import notifications from './notifications';

const locales = window.env.LOCALES;

export default {
    rootPath: window.env.APP_URL,
    currentConnection: window.env.LOCALE,
    connections: function() {
        let connections = _.map(locales, (item) => {
            return { id: item.code, name: item.name, link: item.protocol + item.domain + '/admin/'}
        });

        return connections;
    },
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/stores': {
                params: { },
            },
            '^/compliance_tests': {
                params: {  sort: 'expires_at:asc;created_at:desc' },
            },
            '^/compliance_products': {
                params: {
                    filter: 'id(a):$active_compliance_product',
                    sort: 'updated_at:desc' },
            },
            '^/careers': {
                params: { },
            },
            '^/career_applications': {
                params: {  sort: 'created_at:desc' },
            },
            '^/orders': {
                params: { sort: 'order_date:desc', localeBindingIgnore: true }
            },
            '^/order/[\\d]+$': {
                params: { include: 'items', localeBindingIgnore: true }
            },
            '^/customers': {
                params: { filter: 'registered:1', sort: 'registered_at:desc' }
            },
            '^/customer/[0-9]+/login_log': {
                params: { sort: 'created_at:desc' }
            },
            '^/enquiries': {
                params: { sort: 'enquiry_date:desc' }
            },
            '^/consultations': {
                params: { sort: 'created_at:desc' }
            },
            '^/applications': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { filter: 'email_verified:1', sort: 'created_at:desc' }
            },
            '^/warranties': {
                params: {  sort: 'created_at:desc' },
            },
            '^/quotes_stores': {
                params: {  sort: 'created_at:desc' },
            },
            '^/quotes_platinums': {
                params: {  sort: 'created_at:desc' },
            },
            '^/quotes_customers': {
                params: {  sort: 'created_at:desc' },
            },
            '^/news_posts': {
               params: {  sort: 'position:desc' },
            },
            '^/discount_ranges': {
                params: {  sort: 'min:asc' },
            },
            '^/feedback': {
                params: {  sort: 'created_at:desc' },
            },
            '^/product/[0-9]+$': {
                params: {  with: 'meta_versions' },
            },
            '^/product/[0-9]+/meta_versions$': {
                params: {  with: null },
            },
            '^/product/[0-9]+/categories': {
                params: {  per_page: 10000 },
            },
            '^/product/[0-9]+/attributes': {
                params: {  per_page: 10000 },
            },
            '^/product/[0-9]+/related_products': {
                params: {  per_page: 10000 },
            },
            '^/product/[0-9]+/related_accessories': {
                params: {  per_page: 10000 },
            },
            '^/downloads': {
                params: {  sort: 'created_at:desc' },
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}
